export const closeModal = () => {
    document.getElementById('my-modal-3').checked = false;
}